import $script from 'scriptjs';
import axios from 'axios';

import {
  socialSessionLoading,
  socialSessionError,
} from 'lib/social-session-helpers';

export default class GoogleLogin {
  constructor(buttonTarget, textTarget, csrfToken, omniauthToken) {
    this.buttonTarget = buttonTarget;
    this.textTarget = textTarget;
    this.csrfToken = csrfToken;
    this.omniauthToken = omniauthToken;
    this.handleGoogleResponse = this.handleGoogleResponse.bind(this);
    this.handleError = this.handleError.bind(this);
    this.init();
  }

  init() {
    socialSessionError(false, this.buttonTarget);

    $script('https://apis.google.com/js/platform.js', this.loadGoogleApi);
  }

  loadGoogleApi = () => {
    window.gapi.load('auth2');
  }

  connect() {
    this.originalText = this.textTarget.innerHTML;

    socialSessionLoading(this.buttonTarget);
    socialSessionError(false, this.buttonTarget);

    this.login();
  }

  login() {
    window.gapi.auth2.authorize({
      client_id: this.buttonTarget.dataset.appId,
      cookie_policy: 'single_host_origin',
      scope: 'email profile',
      response_type: 'code',
    }, this.handleGoogleResponse);
  }

  handleGoogleResponse(response) {
    if (response && !response.error) {
      // google authentication succeed, now post data to server.
      axios.defaults.headers.common['X-CSRF-Token'] = this.csrfToken;
      axios.post(`/users/auth/google_oauth2/callback?state=${this.omniauthToken}`, response).then((req) => {
        if (req.status === 200) {
          window.location.assign(req.request.responseURL);
        } else { this.handleError(); }
      }).catch(this.handleError);
    } else { this.handleError(); }
  }

  handleError() {
    socialSessionLoading(this.buttonTarget, this.originalText);
    socialSessionError(true, this.buttonTarget);
  }
}
